import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./DiamondChit.module.css";
import {insertDiamondRewardApi} from "../http/http";
import Cookies from "js-cookie";
import { LanguageContext } from "./LanguageContext";
import { DIAMOND, pageT } from "../utils/i18n";
 
const DiamondChit = () => {
    const navigate = useNavigate();
    const { lang } = useContext(LanguageContext);
    const t = pageT(lang, DIAMOND);
    const [isOpen, setIsOpen] = useState(false);
    const [rewards, setRewards] = useState([]);

    useEffect(() => {
        const token = Cookies.get("token");
        if (!token)  navigate("/");
    
      }, []);
 
    const handleOpen = () => {
        setIsOpen(true);
    };

const handleClaimRewards = async () => {
     const token = Cookies.get("token");
    try {
        const payload = {
           
            rewards: [
                { name: "2GB Data", type: "Data" },
                { name: "Crown", type: "Special" },
                { name: "100", type: "Points" },
            ],
        };

        const res = await insertDiamondRewardApi({token,payload});
        console.log(res.data,"diamond data---");
        navigate("/home")

    } catch (err) {
        console.error(err,"err-----");
       
    }
};



    const handleBack = () => {
        navigate("/home");
    };
 
    return (
        <div className={classes.container}>
          
            <div className={classes.backgroundFx}>
                <div className={classes.rays}></div>
                <div className={classes.p1}></div>
                <div className={classes.p2}></div>
                <div className={classes.p3}></div>
                <div className={classes.p4}></div>
            </div>
 
            <h1 className={classes.title}> {t.title}</h1>
 
            <div className={classes.scene}>
                
                <div
                    className={`${classes.diamondEnvelope} ${isOpen ? classes.open : ''}`}
                    onClick={!isOpen ? handleOpen : undefined}
                >
                    <div className={classes.envelopeBack}></div>
 
                    <div className={classes.envelopeContent}>
                    
                        <div className={`${classes.rewardItem} ${classes.dataReward}`}>
                            <div className={classes.shine}></div>
                            <span>2GB<br />{t.data}</span>
                        </div>
 
                  
                        <div className={`${classes.rewardItem} ${classes.crownReward}`}>
                            <div className={classes.crownVisual}>
                                <div className={classes.crown3d}>
                                
                                    <div className={classes.crownSide} style={{ '--i': 0 }}></div>
                                    <div className={classes.crownSide} style={{ '--i': 1 }}></div>
                                    <div className={classes.crownSide} style={{ '--i': 2 }}></div>
                                    <div className={classes.crownSide} style={{ '--i': 3 }}></div>
                                    <div className={classes.crownSide} style={{ '--i': 4 }}></div>
                                    <div className={classes.crownSide} style={{ '--i': 5 }}></div>
                                    <div className={classes.crownSide} style={{ '--i': 6 }}></div>
                                    <div className={classes.crownSide} style={{ '--i': 7 }}></div>
                                    
                                </div>
                            </div>
                        </div>
 
                     
                        <div className={`${classes.rewardItem} ${classes.pointsReward}`}>
                            <div className={classes.shine}></div>
                            <span>100<br />{t.points}</span>
                        </div>
                    </div>
 
                    <div className={classes.envelopeFront}></div>
                    <div className={classes.envelopeFlap}></div>
                </div>
            </div>
 
            {isOpen ? (
                <div className={classes.messageContainer}>
                
                   <button
    className={classes.backButton}
    onClick={handleClaimRewards}
>
    {t.claimAll}
</button>

                </div>
            ) : (
                <p className={classes.hint}>{t.hint}</p>
            )}
        </div>
    );
};
 
export default DiamondChit;